import { c as _c } from "react/compiler-runtime";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { teamDisplayProperties } from "@components/table/teams/teams-table-utils";
import { alpha, Stack } from "@mui-wrapper";
import { grey, HEX_ALPHA, TeamIcon, Text, Tooltip } from "@flat-ui";
import { withEllipsis } from "@styles/common-styles";
import { TeamNameTooltip } from "@components/table/teams/team-name-tooltip";

/** Time to wait between hover and open the dialog */
const enterDelay = 200;
/**
 * The surface of this tooltip is a plain hover card rather than the dark design-system tooltip,
 * so it opts out of the background, the border and the tighter padding flat-ui gives a plain one.
 */
const tooltipSx = {
  backgroundColor: "background.paper",
  border: "none",
  borderRadius: "4px",
  boxShadow: `0px 3px 3px 0px ${alpha(grey[500], HEX_ALPHA.alpha33)}`,
  maxWidth: "20.75em",
  py: 1,
  px: 2
};

/**
 * The TeamName component displays a team's group name and, if available, a description of the group.
 */
export function TeamName(t0) {
  const $ = _c(16);
  const {
    team
  } = t0;
  let t1;
  if ($[0] !== team) {
    t1 = <TeamNameTooltip team={team} />;
    $[0] = team;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "block"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: "8px",
      flexDirection: "row",
      alignItems: "center",
      ...withEllipsis,
      "&:hover": {
        color: "primary.main"
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TeamIcon sx={{
      width: "20px",
      height: "20px"
    }} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = teamDisplayProperties[team.category.kind];
  let t6;
  if ($[5] !== t5.color) {
    t6 = <SphereAvatar icon={t4} size="small" shouldHideWhiteRim={true} backgroundColor={t5.color} />;
    $[5] = t5.color;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      ...withEllipsis,
      color: "inherit"
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== team.name) {
    t8 = <Text variant="heading12" component="var" sx={t7}>{team.name}</Text>;
    $[8] = team.name;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t8) {
    t9 = <Stack component="div" sx={t3}>{t6}{t8}</Stack>;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t1 || $[14] !== t9) {
    t10 = <Tooltip enterDelay={enterDelay} enterNextDelay={enterDelay} placement="bottom" title={t1} tooltipSx={tooltipSx} sx={t2}>{t9}</Tooltip>;
    $[13] = t1;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
}